/* eslint-disable sort-keys */
import { ImgElementStyle } from './types';

export const imgBaseStyle: ImgElementStyle = {
  border: 'none',
  bottom: 0,
  boxSizing: 'border-box',
  display: 'block',
  height: 0,
  left: 0,
  margin: 'auto',
  maxHeight: '100%',
  maxWidth: '100%',
  minHeight: '100%',
  minWidth: '100%',
  padding: 0,
  position: 'absolute',
  right: 0,
  top: 0,
  width: 0,
};

export const wrapperBaseStyle: React.CSSProperties = {
  background: 'none',
  border: 0,
  boxSizing: 'border-box',
  display: 'block',
  height: 'initial',
  margin: 0,
  opacity: 1,
  overflow: 'hidden',
  padding: 0,
  width: 'initial',
};

export const sizerBaseStyle: React.CSSProperties = {
  background: 'none',
  border: 0,
  boxSizing: 'border-box',
  display: 'block',
  height: 'initial',
  margin: 0,
  opacity: 1,
  padding: 0,
  width: 'initial',
};

export const sizerImageStyle: React.CSSProperties = {
  background: 'none',
  border: 0,
  display: 'block',
  height: 'initial',
  margin: 0,
  maxWidth: '100%',
  opacity: 1,
  padding: 0,
  width: 'initial',
};
